import { render, staticRenderFns } from "./UserSelectComponent.vue?vue&type=template&id=956437e0"
import script from "./UserSelectComponent.vue?vue&type=script&lang=js"
export * from "./UserSelectComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports